export default [
	{//系统用户
		path: 'users',
		name: 'm_sysuser',
		meta: {
			templateManage: {
				workType: 27,
				print: 'b_sysuser_printtemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/system/sysuser_list')
	}, {//部门管理
		path: 'department',
		name: 'm_department',
		props: route => route.params,
		component: () => import('@/pages/system/department_list')
	}, {
		path: 'factory',
		name: 'm_factory',
		props: route => route.params,
		component: () => import('@/pages/system/factory_info')
	}
];